(function(){
/* Tiroir de panier Kalleus : dessiné depuis /cart.js, quantités et suppression via /cart/change.js.
   window.klCart.open() l'ouvre (appelé par la fiche après l'ajout au panier). Sur /cart, il est posé dans la page. */
var root = document.querySelector('[data-klt]');
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var itemsBox = root.querySelector('[data-klt-items]');
var countEl = root.querySelector('[data-klt-count]');
var totalEl = root.querySelector('[data-klt-total]');
var saveEl = root.querySelector('[data-klt-save]');
var upBox = root.querySelector('[data-klt-upsell]');
var upVariant = root.dataset.upsellVariant;
var badgeText = root.dataset.badge || '-[montant]';
var saveText = root.dataset.save || 'Économie [montant]';
var offerText = root.dataset.offer || 'Offre spéciale';
var currency = 'EUR';
var mount = document.querySelector('[data-klcart-mount]');
var inline = !!mount;

function esc(v){ return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
function money(c){ return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: currency }); }
function img(url){ if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
var tagSvg = '<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.4 11.6 12.4 2.6A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .53.21 1.04.59 1.41l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.82zM6.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>';
var binSvg = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';

/* Prix barrés des produits (le panier Shopify ne les donne pas) : lus une fois par produit */
var compare = {}, seen = {};
function loadCompare(cart){
  var todo = [];
  cart.items.forEach(function(i){ if (!seen[i.handle]) { seen[i.handle] = 1; todo.push(i.handle); } });
  return Promise.all(todo.map(function(h){
    return fetch('/products/' + h + '.js').then(function(r){ return r.json(); }).then(function(p){
      (p.variants || []).forEach(function(v){ if (v.compare_at_price > v.price) compare[v.id] = v.compare_at_price; });
    }).catch(function(){});
  })).then(function(){ return cart; });
}
function wasLine(i){ return Math.max(i.original_line_price, (compare[i.variant_id] || 0) * i.quantity); }

function itemHtml(i){
  var was = wasLine(i);
  var off = was - i.final_line_price;
  var tags = [];
  (i.line_level_discount_allocations || []).forEach(function(d){
    var t = d.discount_application && d.discount_application.title;
    if (t && tags.indexOf(t) < 0) tags.push(t);
  });
  if (!tags.length && compare[i.variant_id]) tags.push(offerText);
  var opts = (i.options_with_values || []).filter(function(o){ return o.value !== 'Default Title'; }).map(function(o){ return o.value; }).join(', ');
  var h = '<div class="klt-item" data-key="' + esc(i.key) + '">';
  h += '<a class="klt-item__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image)) + '" alt="" loading="lazy">' : '') + '</a>';
  h += '<div class="klt-item__mid"><a class="klt-item__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>';
  if (opts) h += '<span class="klt-item__opts">' + esc(opts) + '</span>';
  h += '<div class="klt-item__row"><span class="klt-qty"><button type="button" data-klt-q="-1" aria-label="Diminuer">−</button><span>' + i.quantity + '</span><button type="button" data-klt-q="1" aria-label="Augmenter">+</button></span>';
  h += '<button type="button" class="klt-item__remove" data-klt-remove aria-label="Retirer">' + binSvg + '</button></div>';
  tags.forEach(function(t){ h += '<span class="klt-item__tag">' + tagSvg + esc(t) + '</span>'; });
  h += '</div><div class="klt-item__prices"><span class="klt-item__price">' + money(i.final_line_price) + '</span>';
  if (off > 0) h += '<s class="klt-item__was">' + money(was) + '</s><span class="klt-item__off">' + esc(badgeText.replace('[montant]', money(off))) + '</span>';
  return h + '</div></div>';
}

function render(cart){
  currency = cart.currency || 'EUR';
  root.classList.toggle('is-empty', !cart.item_count);
  root.querySelector('[data-klt-empty]').hidden = !!cart.item_count;
  if (countEl) countEl.textContent = cart.item_count;
  itemsBox.innerHTML = cart.items.map(itemHtml).join('');
  totalEl.textContent = money(cart.total_price);
  var saved = cart.items.reduce(function(s, i){ return s + wasLine(i) - i.final_line_price; }, 0) + (cart.items_subtotal_price - cart.total_price);
  saveEl.hidden = saved <= 0;
  saveEl.textContent = saveText.replace('[montant]', money(saved));
  if (upBox) upBox.hidden = !upVariant || cart.items.some(function(i){ return String(i.variant_id) === String(upVariant); });
  /* garder l'icône panier du thème à jour */
  document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
}
function load(){
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(loadCompare).then(function(c){ render(c); return c; });
}
function change(key, qty, el){
  if (el) el.classList.add('is-busy');
  return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
    .then(function(r){ return r.json(); }).then(loadCompare).then(render).catch(load);
}

itemsBox.addEventListener('click', function(e){
  var row = e.target.closest('.klt-item'); if (!row) return;
  var q = e.target.closest('[data-klt-q]'), rm = e.target.closest('[data-klt-remove]');
  if (!q && !rm) return;
  var cur = parseInt(row.querySelector('.klt-qty span').textContent, 10) || 0;
  change(row.dataset.key, rm ? 0 : Math.max(0, cur + parseInt(q.dataset.kltQ, 10)), row);
});
var addBtn = root.querySelector('[data-klt-up-add]');
if (addBtn) addBtn.addEventListener('click', function(){
  addBtn.disabled = true;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(upVariant), quantity: 1 }] }) })
    .then(load).catch(function(){}).then(function(){ addBtn.disabled = false; });
});

/* Le tiroir panier d'origine du thème (#cart-drawer) ne doit jamais s'afficher en plus du nôtre */
function closeThemeDrawer(){
  var host = document.getElementById('cart-drawer');
  if (!host) return;
  var d = host.tagName === 'DIALOG' ? host : host.querySelector('dialog');
  if (typeof host.close === 'function' && host.tagName !== 'DIALOG') { try { host.close(); } catch (e) {} }
  if (d && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
  document.querySelectorAll('[aria-controls="cart-drawer"]').forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
}
closeThemeDrawer();
function open(){
  closeThemeDrawer();
  startTimer();
  if (inline) { load(); return; }
  root.hidden = false;
  document.documentElement.classList.add('klt-lock');
  load();
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-open'); }); });
}
function close(){
  if (inline) return;
  root.classList.remove('is-open');
  document.documentElement.classList.remove('klt-lock');
  setTimeout(function(){ if (!root.classList.contains('is-open')) root.hidden = true; }, 300);
}
root.addEventListener('click', function(e){ if (e.target.closest('[data-klt-close]')) close(); });
document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
window.klCart = { open: open, close: close, refresh: load };

/* Icône panier du thème : ouvrir le tiroir Kalleus au lieu du tiroir d'origine ou de /cart.
   Écouté sur window en phase de capture, donc avant les écouteurs du thème. */
window.addEventListener('click', function(e){
  if (inline || !e.target.closest) return;
  var a = e.target.closest('a[href="/cart"], a[href$="/cart"], [aria-controls="cart-drawer"], .header-actions__cart-icon, cart-icon');
  if (!a || root.contains(a)) return;
  e.preventDefault(); e.stopImmediatePropagation();
  open();
}, true);

/* Même échéance que le compte à rebours de la fiche produit. */
var clock = root.querySelector('[data-klt-clock]');
var timerOn = false;
function startTimer(){
  if (timerOn || !clock) return;
  timerOn = true;
  var end = Number(window.klOfferDeadline);
  if (!end) { try { end = Number(sessionStorage.getItem('kl_offer_end')); } catch (e) {} }
  if (!end || !isFinite(end)) {
    end = Date.now() + 258000;
    try { sessionStorage.setItem('kl_offer_end', String(end)); } catch (e) {}
  }
  var interval;
  var tick = function(){
    var left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    clock.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    if (left === 0 && interval) clearInterval(interval);
  };
  tick();
  interval = setInterval(tick, 1000);
}

if (inline){
  mount.appendChild(root);
  root.classList.add('klt--inline', 'is-open');
  root.hidden = false;
  startTimer();
  load();
}
})();
